const RESOURCE_NAME = "entities/attendances";

export default {};
